import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    filtersOptions: {
      type: Array,
      required: true,
    },
    selectedValues: {
      type: Object,
      required: true,
    },
    campaign: {
      type: Object,
      required: true,
    },
  },
})
export default class CustomCampaignFiltersBarComponent extends Vue {
  showModal = false;
  filterSelectedOption = '';
  selectedModalName = '';
  sortOption = '';
  appliedFilter = {};
  max_price = null;
  min_price = null;

  openModal(filter) {
    this.selectedModalName = filter;
    this.$emit('showBackgroundFilter', true);
  }

  closeModal() {
    this.selectedModalName = '';
    this.filterSelectedOption = '';
    this.$emit('showBackgroundFilter', false);
  }

  selectOption(title) {
    return this.filterSelectedOption === title;
  }

  updateFilters() {
    if (this.selectedModalName === 'price_range') {
      this.filterSelectedOption = `${this.min_price},${this.max_price}`;
    }
    this.$emit('updateFilter', {
      filter: this.selectedModalName,
      option: this.filterSelectedOption,
      sort: this.sortOption,
    });
    this.appliedFilter = {
      filter: this.selectedModalName,
      option: this.filterSelectedOption,
      sort: this.sortOption,
    };
    this.closeModal();
  }

  clearFilter() {
    this.appliedFilter = {};
    this.sortOption = '';
    this.$emit('updateFilter', { filter: 'none', option: '-1', sort: '' });
  }

  isSelected(name) {
    return Object.prototype.hasOwnProperty.call(this.selectedValues, name);
  }
}
